import React from "react";

import { createSharedData } from "components/Share";

import { ICustomTheme } from "../types";
import { Actions } from "../configuration/themeConfigurationReducer";

const { ShareProvider, useShareConsumer } = createSharedData<{
  theme: ICustomTheme;
  dispatch: React.Dispatch<Actions>;
}>();

export {
  useShareConsumer as useConfigurationThemeConsumer,
  ShareProvider as ConfigurationThemeProvider,
};
